import React from 'react';

const Default = ({ description }) => {
  return (
    <React.Fragment>
      <p>{description}</p>
    </React.Fragment>
  )
};

const Achievements = () => {
  return (
    <React.Fragment>
      <p>
        Retrieve the achievements for the streamer from Steam. See how far off they are from achieving Dead God!
      </p>
    </React.Fragment>
  )
};

const Activate = () => {
  return (
    <React.Fragment>
      <p>
        Activates the current active item in Isaac's inventory. This command does not require a battery charge,
        and does not deplete the battery when used.
      </p>
    </React.Fragment>
  )
};

const Algiz = () => {
  return (
    <React.Fragment>
      <p>
        This command is a shortcut for giving and activating the Algiz rune. This rune grants a shield which lasts for 30 seconds. All runes will display the
        corresponding rune symbol on the screen when successful.
      </p>
    </React.Fragment>
  )
};

const Ansuz = () => {
  return (
    <React.Fragment>
      <p>
        This command is a shortcut for giving and activating the Ansuz rune. This rune reveals the whole map, including the Secret Room and the Super Secret
        Room. All runes will display the corresponding rune symbol on the screen when successful.
      </p>
    </React.Fragment>
  )
};

const Award = () => {
  return (
    <React.Fragment>
      <p>
        Spawns the award for the current room when it is cleared of enemies. This can be used to spawn/respawn the large chest or challange trophy in the
        appropriate rooms.
      </p>
    </React.Fragment>
  )
};

const Berkano = () => {
  return (
    <React.Fragment>
      <p>
        This command is a shortcut for giving and activating the Berkano rune. This rune summons 3 friendly blue flies and 3 friendly blue spiders. All runes
        will display the corresponding rune symbol on the screen when successful.
      </p>
    </React.Fragment>
  )
};

const Bless = () => {
  return (
    <React.Fragment>
      <p>
        This command will bless the current level by removing all curses. This will not impact hard coded curses that are a part of some challanges, such
        as Ultra Hard. This will also not remove Curse of the Labyrinth as it impacts the seed of the first floor. Audio feedback will be heard when this
        command is triggered.
      </p>
    </React.Fragment>
  )
};


const Blind = () => {
  return (
    <React.Fragment>
      <p>
        Makes Isaac wear a blindfold, causing his tears to not be shot. There is no way to circumvent the blindfold once enabled, and will require alternative
        methods of doing damage without tears.
      </p>
    </React.Fragment>
  )
};

const Curse = () => {
  return (
    <React.Fragment>
      <p>
        The <strong>!curse</strong> command will allow you to add a curse to the current level. This command requires an additional parameter to specify
        the curse you want to afflict to the level. Following are the available curses:
      </p>
      <ul>
        <li><code>!curse blind</code> - All items are replaced with a question mark and are not revealed until they are picked up.</li>
        <li><code>!curse cursed</code> - Changes normal doors into cursed doors.</li>
        <li><code>!curse darkness</code> - The floor is much, much darker, and is only barely lit by the player's natural aura.</li>
        <li><code>!curse lost</code> - Removes the map from the HUD. Same effect as the Amnesia pill.</li>
        <li><code>!curse maze</code> - Entering a new room (including teleporting) will occasionally take Isaac to the wrong room, with a screenshake and sound effect to indicate the jump.</li>
        <li><code>!curse unknown</code> - Removes Isaac's health from the HUD, leaving the player unable to see how many hearts remain of any kind.</li>
      </ul>
      <p>
        <strong>Note</strong>: Due to the nature of Curse of the Labyrinth, it is not possible to inflict this curse when the game has already started.
      </p>
    </React.Fragment>
  )
};

const Dagaz = () => {
  return (
    <React.Fragment>
      <p>
        This command is a shortcut for giving and activating the Dagaz rune. This rune is similar to the <code>!bless command</code>, and has the same restrictions,
        however will grant a soul heart as well. All runes will display the corresponding rune symbol on the screen when successful.
      </p>
    </React.Fragment>
  )
};

const DressUp = () => {
  return (
    <React.Fragment>
      <p>
        Dress Isaac up in the specified costume. This is purely a cosmetic change, and will not alter stats or provide effects granted by those costumes. Available costumes:
      </p>
      <ul>
        <li>Explosive Diarrhea</li>
        <li>Puberty</li>
        <li>I Found Pills</li>
        <li>Lord Of The Flies</li>
        <li>Statue</li>
        <li>Guppy</li>
        <li>Wizard</li>
        <li>Magdalene</li>
        <li>Cain</li>
        <li>Judas</li>
        <li>Eve</li>
        <li>Azazel</li>
        <li>Eden</li>
        <li>Samson</li>
        <li>Blindfold</li>
        <li>Blankface</li>
        <li>Christmas</li>
        <li>Purity Glow</li>
        <li>Empty Vessel</li>
        <li>Maw Mark</li>
        <li>Mushroom</li>
        <li>Angel</li>
        <li>Bob</li>
        <li>Drugs</li>
        <li>Mom</li>
        <li>Baby</li>
        <li>Evil Angel</li>
        <li>Poop</li>
        <li>Relax</li>
        <li>Overdose</li>
        <li>Boomerang</li>
        <li>Megablast</li>
        <li>Lazarus</li>
        <li>Lazarus2</li>
        <li>Lilith</li>
        <li>Iwata</li>
        <li>Apollyon</li>
        <li>Bookworm</li>
        <li>Adulthood</li>
        <li>Spiderbaby</li>
        <li>Batwing Wings</li>
        <li>Huge Growth</li>
        <li>Era Walk</li>
        <li>Sacrificial Altar</li>
        <li>Forgotten</li>
        <li>Brimstone2</li>
        <li>Holy Card</li>
        <li>Keeper</li>
        <li>Spin To Win</li>
        <li>Bethany</li>
        <li>Jacob</li>
        <li>Esau</li>
        <li>Blood Oath</li>
        <li>Intruder</li>
        <li>Sol</li>
        <li>It Hurts</li>
        <li>Mars</li>
        <li>Tooth And Nail</li>
        <li>Reverse Magician</li>
        <li>Reverse High Priestess</li>
        <li>Reverse Empress</li>
        <li>Reverse Chariot</li>
        <li>Reverse Strength</li>
        <li>Reverse Hanged Man</li>
        <li>Reverse Sun</li>
        <li>Reverse Devil</li>
        <li>Reverse Chariot Alt</li>
        <li>Reverse Temperance</li>
        <li>Reverse Stars</li>
        <li>Wavy Cap 1</li>
        <li>Wavy Cap 2</li>
        <li>Wavy Cap 3</li>
        <li>Luna</li>
        <li>Jupiter Body</li>
        <li>Jupiter Body Angel</li>
        <li>Jupiter Body Pony</li>
        <li>Jupiter Body Whitepony</li>
        <li>Isaac B</li>
        <li>Magdalene B</li>
        <li>Cain B</li>
        <li>Judas B</li>
        <li>Bluebaby B</li>
        <li>Eve B</li>
        <li>Samson B</li>
        <li>Azazel B</li>
        <li>Lazarus B</li>
        <li>Eden B</li>
        <li>Lost B</li>
        <li>Lilith B</li>
        <li>Keeper B</li>
        <li>Apollyon B</li>
        <li>Forgotten B</li>
        <li>Bethany B</li>
        <li>Jacob B</li>
        <li>Azazels Rage 1</li>
        <li>Azazels Rage 2</li>
        <li>Azazels Rage 3</li>
        <li>Azazels Rage 4</li>
        <li>Esau Jr</li>
        <li>Spirit Shackles Soul</li>
        <li>Spirit Shackles Disabled</li>
        <li>Berserk Samson</li>
        <li>Lazarus2 B</li>
        <li>Soul B</li>
        <li>Forgotten Bomb</li>
        <li>Extra Big Fan</li>
        <li>Jacob2 B</li>
        <li>Jacobs Curse</li>
        <li>Bloody Babylon</li>
        <li>Dark Arts</li>
        <li>Lost Curse</li>
        <li>Lazarus Soul Revive</li>
        <li>Soul Magdalene</li>
        <li>Soul Bluebaby</li>
        <li>Mirror Death</li>
        <li>Hemoptysis</li>
        <li>I Found Horse Pills</li>
        <li>Horse Puberty</li>
        <li>Soul Forgotten</li>
        <li>Soul Jacob</li>
      </ul>
    </React.Fragment>
  )
};

const Ehwaz = () => {
  return (
    <React.Fragment>
      <p>
        This command is a shortcut for giving and activating the Ehwaz rune. This rune creates a trapdoor leading to the next floor. It has an estimated 1/12 (8%)
        chance to spawn a door to a Crawl Space instead. All runes will display the corresponding rune symbol on the screen when successful.
      </p>
    </React.Fragment>
  )
};
  
const Fart = () => {
  return (
    <React.Fragment>
      <p>
        This command will make Isaac fart. On success, it will fart. Do you need anymore affirmation?
      </p>
    </React.Fragment>
  )
};

const Friend = () => {
  return (
    <React.Fragment>
      <p>
        This command will spawn a friendly companion to Isaac. This friend will be a randomly chosen enemy in the game, colored in a unique color, and will have
        the chatters name on it. The friend will attack other enemies in the game, and has it's own health. You can change your friend by doing <code>!friend</code>
        again - this will not stack multiple friends, but despawn the previous one.
      </p>
      <p>
        Subscribers to the channel can optionally specify a friend to spawn; i.e. <code>!friend greed gaper</code> will spawn a Greed Gaper in to the game. this
        is only enabled for subscribers, and will default to a random friend.
      </p>
    </React.Fragment>
  )
};

const Genocide = () => {
  return (
    <React.Fragment>
      <p>
        Does massive damage to every enemy in the current room -- this is the same effect as Mama Mega, however localized to the current room only.
      </p>
    </React.Fragment>
  )
};

const Give = () => {
  return (
    <React.Fragment>
      <p>
        The <code>!give</code> command can be used to give Isaac items directly. The command requires an additional parameter to indicate the item that you want
        to give to Isaac. Items can be <strong>Collectibles</strong>, <strong>Trinkets</strong>, <strong>Cards</strong>, or <strong>Pills</strong>. You can use&nbsp;
        <a href="https://platinumgod.co.uk/afterbirth-plus" target="_new">Platinum God's Isaac Cheat Sheet</a> to find item names quickly, and the search feature
        will let you find items based on status effects (e.g. you can search for "health up" to find all items that increase the health stat.
      </p>
      <p>
        Item names are <strong>NOT</strong> case-sensitive, and allow for plenty of leeway in punctuation, spaces, and prefixes - it also does fuzzy matching
        of item names, so some mispellings will work!
      </p>
      <p>
        <strong>Collectibles</strong><br />
        Collectibles are active and passive items that are a large part of the game play in The Binding of Isaac. Collectibles modify Isaac's attributes,
        grant or modify tear effects, and much more. Collectibles can be given either by the item name, e.g. <code>!give brimstone</code>, or via the item ID
        with the c prefix, e.g. <code>!give c118</code>. Additionally, you can specify that the item name you want to give is part of collectibles collection
        by using <code>!give collectible cancer</code> to avoid item name conflicts (for example, Cancer is both a collectible as well as a trinket - if note
        specified, the collectible version will be found first).
      </p>
      <p>
        <strong>Trinkets</strong><br />
        Trinkets are a kind of collectible, however they have their own designated slot and are always passive modifiers to the game play. Trinkets can be given
        either by the item name, e.g. <code>!give goat hoof</code>, or via the trinket ID with the t prefix, e.g. <code>!give t37</code>. Additionally, you can
        specify that the trinket name you want to give is part of trinkets collection by using <code>!give trinket cancer</code> to avoid name conflicts (for
        example, Cancer is both a collectible as well as a trinket). If you give a trinket, and Isaac already has one, it will replace it with the new one.
        This will always replace the first trinket in the event that Isaac has Mom's Purse or Belly Button which grants an additional Trinket slot. If the
        current item is Tick, it will be replaced without needing Match Stick.
      </p>
      <p>
        <strong>Cards</strong><br />
        Cards are a consumable item that are one time use, and take up space in the consumables slot, together with Pills. Cards includes Runes, as well as
        special items considered cards in the game, such as Dice Shard and Emergency Contact. Cards can be given either by the item name, e.g.
        <code>!give ace of diamonds</code>, or via the card ID with the k prefix, e.g. <code>!give k28</code>. Additionally, you can specify that the card
        name you want to give is part of the cards collection by using <code>!give card the tower</code>. For the tarot card names, e.g. VIII - Justice, you
        do not need to include the roman numeral prefix as it will find the card without it, e.g. <code>!give justice</code>. When giving cards, they will
        automatically trigger their action - so in the case of <code>!give temperance</code>, the card will be immediately consumed, and a blood donation machine
        will spawn.
      </p>
      <p>
        <strong>Pills</strong><br />
        Pills are a consumable item that are one time use, and take up space in the consumables slot, together with Cards. Pills can be given either by the pill
        name, e.g. <code>give speed up</code>!, or via the pill ID with the p prefix, e.g. <code>!give p14</code>. Additionally, you can specify that the pill
        name you want to give is part of the pills collection by using <code>!give pill retro vision</code>. If you give a pill, and Isaac already has one, it will
        replace it with the new one.<br />
        <strong>Note</strong>: Unlike Cards, Pills are NOT automatically consumed!
      </p>
    </React.Fragment>
  )
}

const Heal = () => {
  return (
    <React.Fragment>
      <p>
        Heal all of Isaac's empty heart containers. This command will not add additional heart containers, and if Isaac's life is full, nothing will happen.
      </p>
    </React.Fragment>
  )
}

const Help = () => {
  return (
    <React.Fragment>
      <p>
        Returns a link to this page! The help page linked to will be customized to the streamers preferences of which commands are enabled or disabled.
      </p>
    </React.Fragment>
  )
}

const Jera = () => {
  return (
    <React.Fragment>
      <p>
        This command is a shortcut for giving and activating the Jera rune. This rune clones all pickups and chests in a room. All runes will display the
        corresponding rune symbol on the screen when successful.
      </p>
    </React.Fragment>
  )
}

const McDuck = () => {
  return (
    <React.Fragment>
      <p>
        Applies a Ultra Greed treatment to the current room and turns it in to gold. While mostly cosmetic, can turn poops in to golden poops.
      </p>
    </React.Fragment>
  )
}

const Naked = () => {
  return (
    <React.Fragment>
      <p>
        This command will remove all items from Isaac, leaving him with nothing. Stats that were modified on-pickup, and do not depend on Isaac still having the
        item, will not be modified.
      </p>
    </React.Fragment>
  )
}

const Open = () => {
  return (
    <React.Fragment>
      <p>
        If this command is enabled, spawned chests will have a 25% chance of being replaced with a Twitch Chest. Twitch Chests can not be opened unless chat uses 
        the <code>!open</code> command. Once opened, a Twitch Chest will spawn a random collectible on a pedestal, not limited to any item pool.
      </p>
    </React.Fragment>
  )
}

const Perthro = () => {
  return (
    <React.Fragment>
      <p>
        This command is a shortcut for giving and activating the Perthro rune. This rune rerolls all pedestal items in the room. All runes will
        display the corresponding rune symbol on the screen when successful.
      </p>
    </React.Fragment>
  )
}

const Pocket = () => {
  return (
    <React.Fragment>
      <p>
        Move the current active item in to the pocket slot.
      </p>
    </React.Fragment>
  )
};

const Quake = () => {
  return (
    <React.Fragment>
      <p>
        Shakes the current screen like an earthquake.
      </p>
    </React.Fragment>
  )
}

const Repeat = () => {
  return (
    <React.Fragment>
      <p>
        This command allows you to repeat a command multiple times. Not all commands are repeatable, and in those cases the command will only trigger once.<br />
        Examples:
      </p>
      <ul>
        <li><code>!repeat 5 give 20/20</code> will give Isaac the 20/20 item 5 times.</li>
        <li><code>!repeat 3 spawn Gaping Maw</code> will spawn the Gaping Maw enemy 3 times.</li>
      </ul>
      <p>
        There are various restrictions and safe guards in place for this command:
      </p>
      <ul>
        <li>The count is limited to 5 for non-subscribers.</li>
        <li>The count is limited to 25 for subscribers.</li>
        <li>As a limit imposed by !spawn, enemies will only allow up to 20 enemies in a room, so any additional will be ignored.</li>
        <li>As a limit imposed by !spawn, bosses will only allow up to 5 bosses in a room, so any additional will be ignored.</li>
        <li>You can not repeat the !repeat command, duh.</li>
      </ul>
    </React.Fragment>
  )
}

const Seed = () => {
  return (
    <React.Fragment>
      <p>
        This command will let the Twitch chat know what the seed of the current run is.
      </p>
    </React.Fragment>
  )
}

const Shart = () => {
  return (
    <React.Fragment>
      <p>
        This command is a equivelant to using a Card Against Humanity card, and will fill the current rooms available spaces with poop. Once a tile has had
        poop on it, it is no longer considered an available tile - so sharting twice in the same room will generally not give you anything new.
      </p>
    </React.Fragment>
  )
}

const Spawn = () => {
  return (
    <React.Fragment>
      <p>
        The <code>!spawn</code> command is very similar to the <code>!give</code> command, however instead of giving Isaac the item directly, it will spawn it 
        in the current room. In addition to item spawning, <code>!spawn</code> is also able to spawn enemy monsters in to the current room. Monsters are spawned
        via their name, e.g. <code>!spawn attack fly</code>. A list of monster names can be found on&nbsp;
        <a href="https://bindingofisaacrebirth.gamepedia.com/Monsters" target="_new">the Binding of Isaac Wiki</a>. Monsters can be spawned in as champions - however
        this is random and the game engine decides when to do this. Some things to be aware of with spawning:
      </p>
      <ul>
        <li>If there are 20 or more enemies in the room, spawning an enemy will not work.</li>
        <li>If there are 5 or more bosses in the room, spawning a boss will not work.</li>
      </ul>
      <p>
        If spawning items, you can use the same syntax as in the <code>!give</code> command, including using item codes. While you can not spawn an enemy or boss
        via its ID, you can specify that you intend to spawn an enemy via <code>!spawn enemy sack</code>.
      </p>
    </React.Fragment>
  )
}

const Stat = () => {
  return (
    <React.Fragment>
      <p>
        The <code>!stat</code> command allows modifying various stats of Isaac directly. Stat names that can be modified:
      </p>
      <ul>
        <li><code>speed</code> - How quickly Isaac moves.</li>
        <li><code>range</code> - How long tears will travel before landing.</li>
        <li><code>fire</code> - The tear rate of fire.</li>
        <li><code>shot</code> - How quickly tears travel.</li>
        <li><code>damage</code> - The amount of damage that each tear deals to enemies.</li>
        <li><code>luck</code> - The amount of luck Isaac has - this affects a variety of chance based effects.</li>
      </ul>
      <p>
        The modifier for these stats can be a static value, or be prefixed with a <code>+</code> or <code>-</code> to modify the value of the stat.<br />
        Examples:
      </p>
      <ul>
        <li><code>!stat luck 12</code> - Set Isaac's luck to 12.</li>
        <li><code>!stat damage +3</code> - Increase Isaac's damage by 3.</li>
        <li><code>!stat speed -1</code> - Decrease Isaac's speed by 1.</li>
      </ul>
      <p>
        <strong>Note</strong>: There are built in limits to how high or how low a stat can go. Some are hardcoded by the game engine itself, others are imposed
        by the mod.
      </p>
    </React.Fragment>
  )
}

const Swallow = () => {
  return (
    <React.Fragment>
      <p>
        This command mimics the behavior of the Smelter active item. When triggered, the players current Trinket in the primary slot will be "swallowed" and added as a permanent passive item.
      </p>
    </React.Fragment>
  )
}

const Take = () => {
  return (
    <React.Fragment>
      <p>
        The <code>!take</code> command is the opposite of <code>!give</code>. It will accept all of the same parameters and options for collectibles and trinkets
        as the <code>!give</code> command, except it will take the item away from Isaac. Pills and Cards are not able to be taken away.
      </p>
      <p>
        <strong>Note</strong>: Any item that has a one time stat modification, will not have that modification undone when taken away. For example, Black Candle
        gives Isaac an additional Black Heart, as well as it's other features such as curse immunity and it's Necronomicon style effect. If removed, the Black
        Heart will not be taken away, but the curse immunity will be gone.
      </p>
    </React.Fragment>
  )
}

const Teleport = () => {
  return (
    <React.Fragment>
      <p>
        This command can be used to teleport Isaac in to a new room. When no room is specified, a random destination will be chosen. If the specified room does not
        exist on the current floor, a random destination will be chosed.<br />
        Room types:
      </p>
      <ul>
        <li><code>angel</code></li>
        <li><code>arcade</code></li>
        <li><code>black market</code></li>
        <li><code>boss</code></li>
        <li><code>boss rush</code></li>
        <li><code>challenge</code></li>
        <li><code>chest</code></li>
        <li><code>curse</code></li>
        <li><code>devil</code></li>
        <li><code>dungeon</code></li>
        <li><code>error</code></li>
        <li><code>library</code></li>
        <li><code>miniboss</code></li>
        <li><code>sacrifice</code></li>
        <li><code>secret</code></li>
        <li><code>shop</code></li>
        <li><code>start</code></li>
        <li><code>super secret</code></li>
        <li><code>treasure</code></li>
      </ul>
    </React.Fragment>
  )
}

const Transform = () => {
  return (
    <React.Fragment>
      <p>
        Transform the playing character in to the specified character. Examples:
      </p>
      <ul>
        <li><code>!transform lilith</code></li>
        <li><code>!transform tainted lilith</code></li>
      </ul>
    </React.Fragment>
  )
};

const WTF = () => {
  return (
    <React.Fragment>
      <p>
        Causes blood to pour in to the room from the walls. WTF?!
      </p>
    </React.Fragment>
  )
}

const Commands = {
  'default': Default,
  'achievements': Achievements,
  'activate': Activate,
  'algiz': Algiz,
  'ansuz': Ansuz,
  'award': Award,
  'berkano': Berkano,
  'bless': Bless,
  'blind': Blind,
  'curse': Curse,
  'dagaz': Dagaz,
  'dressup': DressUp,
  'ehwaz': Ehwaz,
  'fart': Fart,
  'friend': Friend,
  'genocide': Genocide,
  'give': Give,
  'heal': Heal,
  'help': Help,
  'jera': Jera,
  'mcduck': McDuck,
  'naked': Naked,
  'open': Open,
  'perthro': Perthro,
  'pocket': Pocket,
  'quake': Quake,
  'repeat': Repeat,
  'seed': Seed,
  'shart': Shart,
  'spawn': Spawn,
  'swallow': Swallow,
  'stat': Stat,
  'take': Take,
  'teleport': Teleport,
  'transform': Transform,
  'wtf': WTF
}

export default Commands;
